export default "__VITE_ASSET__bb6ea7aa__"